import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const RewardName = styled.div`
    font-size: 14px;
    display:flex;
    align-items: center;
    justify-content: end;

    div{
        display:inline-block;
        height:2px;
        width:6px;
        background:#bebebe;
        margin: 0 0 0 3px;
        content:" ";
    }
`;

export const RewardBar = styled.div<{barWidth?:number}>`
    height: 38px;
    padding-top: 4px;

    :hover{
        background:#e0e0e0;
        cursor: pointer;
    }
    
    > div{
        content: " ";
        background:#F87171;
        height: 30px;
        border-radius: 0 6px 6px 0;
        width:${props => props.barWidth?props.barWidth + "%":"0%"};
        transition: width 0.8s ease-in-out;
    }
`;

export const CountBar = styled.div`
    border-top: 2px solid #ececec;
    display:flex;
    justify-content: space-between;

    span{
        display:flex;
        align-items: center;
        flex-direction: column;

        :nth-of-type(5){
            transform: translateX(40%);
        }
    }

    line{
        display:inline-block;
        height:6px;
        width:2px;
        background:#bebebe;
    }
`;